import React,{Fragment} from 'react';
const IsNewOrExistingMistakeSelectionModalBody = (props)  => {
    return (
        <Fragment>
            <div className="row">
                <div className="col-md-6">
                    <button type="button" onClick={(e) => props.handleOnClickMistakeTypeSelection(e,'new')} className="btn btn-primary btn-primary-original btn-block btn-lg">New</button> 
                </div>
                <div className="col-md-6">
                    <button type="button" onClick={(e) => props.handleOnClickMistakeTypeSelection(e,'existing')} className="btn btn-primary btn-primary-original btn-block btn-lg">Existing</button> 
                </div>
            </div>
        </Fragment>
    );
}

export default IsNewOrExistingMistakeSelectionModalBody;